<template lang="html">
  <div class="image-list">
      <img v-for="(item, index) in imageList" :key="'image'+index" :src="item" alt="">
  </div>
</template>

<script>
  export default {
    name: 'ImageList',
    props: {
      imageList: {
        type: Array,
        default: [],
      },
    },
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../style/main";
  .image-list {
    width: 100%;
    img{
      width: 100%;
      vertical-align: top;
    }
  }
</style>